import * as NftActions from './nfts.actions';

export type Attachment = {
    name: string;
    url: string;
}

export type Metadata = {
    tokenId: number;
    artistName: string;
    title: string;
    format: string;
    materials: string;
    dateOfCreation: Date;
}

export type NFT = {
    _id: string;
    tokenId: number;
    tokenUri: string;
    name: string;
    description: string;
    royalty: number;
    creator: string;
    owner: string;
    listed: boolean;
}

export type Voucher = {
    _id?: string;
    name: string;
    description: string;
    tokenId: number;
    tokenUri: string;
    price: string;
    royalty: number;
    creator: string;
    owner: string;
    signature: string;
    message: string;

    resell: boolean;
    listed?: boolean;
    purchased?: boolean;

    position?: string;
    createdAt?: Date;

    artType: number;
    metadata?: Metadata;
    attachments?: Attachment[]
}


/**
 * 1. wallet tokens
 * 2. listed tokens => to show on the art space
 * 3. selected token id 
 * 4. selected nft
 * 5. dropWN
 * 6. dropWNFlag
 * 7. position
 * 8. art textures... ??
 * 9. empty or not
 */
export interface State {
    walletTokens: NFT[];
    listedVouchers: Voucher[];
    selectedNFT: NFT | Voucher | null;
    dropWN: NFT | null;
    dropWNFlag: boolean;
    slot: string;
    loading: boolean;
    nftError: string | null;
    isEmpty: boolean;
}

const initialState: State = {
    walletTokens: [],
    listedVouchers: [],
    selectedNFT: null,
    dropWN: null,
    dropWNFlag: false,
    slot: null,
    loading: false,
    nftError: null,
    isEmpty: true // flag to identify nft actions
}

export function nftReducer(state = initialState, action: any) {
    switch(action.type) {
        case NftActions.GET_WALLET_TOKENS:
            return {
                ...state,
                nftError: null,
                loading: true
            }
        case NftActions.GET_WALLET_TOKENS_SUCCESS:
            return {
                ...state,
                nftError: null,
                loading: false,
                walletTokens: [...action.payload]
            }
        case NftActions.GET_LISTED_VOUCHERS:
            return {
                ...state,
                nftError: null,
                loading: true
            }
        case NftActions.GET_LISTED_VOUCHERS_SUCCESS: 
            const vouchers = [...action.payload] 
            return {
                ...state,
                loading: false,
                nftError: null,
                listedVouchers: vouchers
            }
        case NftActions.LAZY_MINT: 
            return {
                ...state,
                loading: true,
                nftError: null
            }
        case NftActions.LAZY_MINT_SUCCESS:
            const newWalletTokens = [...state.walletTokens, action.payload];
            return {
                ...state,
                walletTokens: newWalletTokens,
                loading: false,
                nftError: null
            }
        case NftActions.NFT_ACTION_FAILED:
            return {
                ...state,
                loading: false,
                nftError: action.payload
            }
        case NftActions.SLOT_CLICKED:
            return {
                ...state,
                slot: action.payload.slot,
                selectedNFT: action.payload.selectedNFT,
                // if tokenId is -1, then it means that a empty slot is clicked
                isEmpty: action.payload.selectedNFT ? false : true
            }
        case NftActions.DROPPED_NFT:
            return {
                ...state,
                selectedNFT: action.payload
            }
        case NftActions.LIST_NFT:
            return {
                ...state,
                loading: true,
                nftError: null
            }
        case NftActions.LIST_NFT_SUCCESS:
            const listedVoucher = action.payload;
            // remove listed voucher from wallet tokens
            const walletTokens = state.walletTokens.filter(token => token.tokenId !== listedVoucher.tokenId);
            
            // add into artworks
            state.listedVouchers.push(listedVoucher);
            const listedVouchers1 = state.listedVouchers.slice();
            return {
                ...state,
                loading: false,
                walletTokens,
                listedVouchers: listedVouchers1
            }
        case NftActions.UNLIST_NFT:
            return {
                ...state,
                loading: true,
                nftError: null
            }
        case NftActions.UNLIST_NFT_SUCCESS:
            const unlistedVoucher = action.payload;

            // remove from artworks
            const unlistedVouchers = state.listedVouchers.filter(v => v.tokenId !== unlistedVoucher.tokenId);

            // add to wallet tokens
            state.walletTokens.push(unlistedVoucher);
            const unlistedWalletTokens = state.walletTokens.slice();

            return {
                ...state,
                selectedNFT: null,
                loading: false,
                listedVouchers: unlistedVouchers,
                walletTokens: unlistedWalletTokens,
                isEmpty: true
            }
        case NftActions.BUY_NFT: 
            return {
                ...state,
                loading: true,
                nftError: null
            }
        case NftActions.BUY_NFT_SUCCESS:
            const purchasedVoucher = action.payload;

            // remove from artworks
            const listedVouchers2 = state.listedVouchers.filter(v => v.tokenId !== purchasedVoucher.tokenId);

            // add to wallet tokens
            state.walletTokens.push(purchasedVoucher);
            const walletTokens2 = state.walletTokens.slice();

            return {
                ...state,
                loading: false,
                selectedNFT: null,
                listedVouchers: listedVouchers2,
                walletTokens: walletTokens2
            }
        case NftActions.RESELL:
            return {
                ...state,
                loading: true,
                nftError: null
            }
        case NftActions.RESELL_SUCCESS:
            const resellVoucher = action.payload;
            state.listedVouchers.push(resellVoucher);
            const resellWalletTokens = state.walletTokens.filter(t => t.tokenId !== resellVoucher.tokenId);
            
            return {
                ...state,
                loading: false,
                selectedNFT: null,
                listedVouchers: state.listedVouchers.slice(),
                walletTokens: resellWalletTokens
            }
        default: 
            return {
                ...state
            }
    }
}